<template>
  <div>
    <modal
      :show.sync="editChapter"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Edit Chapter
      </h6>
      <div>
        <base-input
          v-model="chapter.name"
          placeholder="Enter Chapter Name"
          class="cust-mb0"
        ></base-input>
        <!-- <b-button type="primary"
            >Create Chapter</b-button -->
      </div>
      <template slot="footer">
        <base-button type="primary" @click="edit_Chapter()"
          >EDIT CHAPTER</base-button
        >
        <base-button @click="closeModal" type="secondary" class="ml-auto"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    editChapter: Boolean,
    edit_chapter: Function,
    chapterId: Object,
  },
  data() {
    return {
      chapter: {},
    };
  },
  methods: {
    async edit_Chapter() {
      if (this.chapterId.name.length != 0) {
        try {
          let loader = this.$loading();

          const data = await this.$store.dispatch("eLearning/editChapter", {
            name: this.chapter.name,
            _id: this.chapter._id,
          });

          if (data.code == 200) {
            this.$swal.fire({
              title: "Edited",

              text: "Chapter has been edited Successfully!",

              icon: "success",
              showConfirmButton: false,
              showCancelButton: false,
              timer: 2000,
            });
            loader.close();
            this.closeModal();
          }
        } catch (err) {
          loader.close();
        }
      }
    },
    closeModal() {
      this.$emit("close-editChapter");
    },
  },
  watch: {
    chapterId(newValue, oldValue) {
      // console.log(newValue);
      this.chapter = { ...newValue };
    },
  },
  // computed: {
  //   name: {
  //     get() {
  //       return this.chapterId.name;
  //     },
  //     set(newValue) {
  //       console.log(newValue);
  //       return newValue;
  //     },
  //   },
  // },
};
</script>
